var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"finish-step"},[_c('p',{staticClass:"finish-step__desc"},[_vm._v("VK Pay кошелек идентифицирован")]),_c('Label',{attrs:{"text":"Готово"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }